export default {
  mysteryBoxPending: () => import('./mystery_box_pending.json'),
  mysteryBoxOpen: () => import('./mystery_box_open.json'),
};
